module.exports = __webpack_public_path__ + "img/1.ea6657a4.png";